const SOCIAL_MEDIA_ICON = {
  LINKEDIN: 'linkedin',
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
};

export { SOCIAL_MEDIA_ICON };
